import { render } from "./ProjectCard.vue?vue&type=template&id=4011bccc&scoped=true&ts=true"
import script from "./ProjectCard.vue?vue&type=script&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=4011bccc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4011bccc"]])

export default __exports__